import { render, staticRenderFns } from "./XolasTable.vue?vue&type=template&id=7eb7397f&scoped=true"
import script from "./XolasTable.vue?vue&type=script&lang=js"
export * from "./XolasTable.vue?vue&type=script&lang=js"
import style0 from "./XolasTable.vue?vue&type=style&index=0&id=7eb7397f&prod&scoped=true&lang=css"
import style1 from "./XolasTable.vue?vue&type=style&index=1&id=7eb7397f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eb7397f",
  null
  
)

export default component.exports